import(/* webpackMode: "eager", webpackExports: ["IframesSavingsV2Template"] */ "/app/src/app/iframes/components/IframesSavingsV2Template.tsx");
